module.exports = __webpack_public_path__ + "static/img/login_part02_img01.dd0a29f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_part02_img01.png
// module id = HwtG
// module chunks = 1